import { LocalOverrides } from './extension-api.interfaces';
import { IExtensionApiStrategy } from './extension-api.strategy-interface';

import { ChromeLocalExtensionApiStrategy } from '../strategies/chrome-local.extension-api.strategy';
import { ChromeExtensionApiStrategy } from '../strategies/chrome.extension-api.strategy';

export enum ExtensionApiStrategy {
  CHROME = 'CHROME',
  CHROME_LOCAL = 'CHROME_LOCAL',
  NOT_SET = 'NOT_SET',
}

const ApiIntances: Record<string, IExtensionApiStrategy> = {};
let plocalOverrides: LocalOverrides = {};
let pApiStrategy = ExtensionApiStrategy.NOT_SET;

export const setLocalOverrides = (localOverrides: LocalOverrides) => {
  plocalOverrides = localOverrides;
};

export const setApiStrategy = (apiStrategy: ExtensionApiStrategy) => {
  pApiStrategy = apiStrategy;
};

export const ExtensionApiFactory = (): IExtensionApiStrategy => {
  switch (pApiStrategy) {
    case 'CHROME': {
      let instance = ApiIntances[pApiStrategy];
      if (!instance) {
        instance = new ChromeExtensionApiStrategy();
      }
      return instance;
    }
    case 'CHROME_LOCAL': {
      let instance = ApiIntances[pApiStrategy];
      if (!instance) {
        instance = new ChromeLocalExtensionApiStrategy(plocalOverrides);
      }
      return instance;
    }
    default:
      throw new Error(`invalid strategy type: ${pApiStrategy}`);
  }
};
